export default {
  onboardingSlides: {
    stepChip: "Step {current} of {total}",
  },
  onboardingWelcomeSlide: {
    title: "Welcome to Tokatab!",
    intro: "In just a few minutes, you’ll play your first notes.<br />Ready to begin?",
    start: "Let's go!",
  },
  onboardingTutorialSlide: {
    title: "Your piano is ready, it’s your turn to play!",
    intro: "A tutorial of a few very simple notes to get you started — 2 minutes, promise.",
    doLater: "I'll do it later",
    playTutorial: "I'll play the tutorial",
  },
  onboardingTrialSlideAb: {
    selectTitle: "Subscribe to unlock <br /> all <strong>Tokatab</strong> content and progress quickly at the piano",
    benefit1: "100+ repertoire pieces to learn",
    benefit2: "500+ exercises and videos to learn key piano skills",
    benefit3: "Personalized recommendations from your virtual teacher",
    try14: "Try free for {days} days",
    noSubscribe: "Do not subscribe",
    trialExplanationTitle: "How your trial period works",
    trialStep1Title: "Today",
    trialStep1Desc: "Unlock your full access to Tokatab",
    trialStep2Title: "In {reminderDay} days",
    trialStep2Desc: "You will receive a trial period end reminder",
    trialStep3Title: "In {endDay} days",
    trialStep3Desc: "You will be charged {price} – you can cancel anytime for free before this date",
    trialStep4Title: "In the months and years to come",
    trialStep4Desc: "Enjoy the Tokatab virtual teacher and progress at the piano like never before!",
    startTrial: "Start free trial",
    cancelTitle: "You don't want to enjoy Tokatab Premium?",
    premiumFaster: "Our <strong>Premium users progress on average 4 times faster</strong> than others",
    tryAndCancel: "You can <strong>try for {days} days free</strong> and cancel anytime if you're not convinced",
    noPremiumAccess: "Without Tokatab Premium, you only have access to",
    access1: "Our repertoire of 100+ pieces, to learn independently",
    access2: "2 free challenges",
    access3: "500+ exercises and videos to learn key piano skills",
    access4: "Recommendations from the Tokatab virtual teacher",
    tryPremium: "I try Tokatab Premium for free",
    noThanks: "No thanks",
    subscriptionLabel: "Subscription {label}",
    trialDurationThen: "{days} days trial, then",
  },
  onboardingTrialSlide: {
    title: "Benefit from personalized support 24/7",
    content1: "With our subscription plan, access all <span class='text-bold'>Tokatab's learning resources</span> and benefit from <span class='text-bold'>your virtual teacher's support</span> at any time.",
    content2: "We offer you <span class='text-bold'>{days} free trial days, with no commitment</span>, so you can try out this service.",
    seeOffers: "See offers",
    startTrial: "Enjoy {days} free days",
    error: "An error occurred, please try again...",
  },
  onboardingTrialFreemiumSlide: {
    titleFreemium: 'Tokatab Free',
    titlePremium: 'Tokatab Premium',
    freemiumDay: 'Enjoy <strong>3 free contents</strong> per day (exercises, challenges, or parts of pieces).',
    freemiumWeek: 'Progress for free with <strong>5 free contents</strong> per week (exercises, challenges, or parts of pieces).',
    premium: 'Want to progress even faster? Switch to <strong>Tokatab Premium</strong> at any time to work on unlimited content.',
    info: 'Everyone gets the same content. The free version simply limits how much you can access each {period}.',
    periodDay: 'day',
    periodWeek: 'week',
    tryForFree: 'Try Tokatab for free',
    continue: 'Continue',
  },
  onboardingTeacherSlide: {
    chooseTitle: "Choose your Tokatab coach",
    chooseInfo: "You can change this choice later.",
    continue: "Continue",
    selectedTitle: "Nice to meet you, {name}!",
    selectedTitleNoName: "Nice to meet you!",
    selectedInfo: "I'll be your guide: at every step, I'll advise you based on your progress and your goals.",
  },
  onboardingSingSlide: {
    title: 'Piano-vocal !',
    intro: 'Piano accompaniment while singing is a common and rewarding skill. Would you like to learn how to accompany yourself while singing?',
    details: "Throughout your learning journey, we can cover piano-vocal techniques and work on popular songs.<br>To offer them in the keys best suited to your voice, I suggest you take a vocal range test!<br><br>(Your vocal range is the span of notes your voice can sing)",
    askTest: 'Would you like to take the test now?',
    footer: "If you can't take the test now, you can access it later in your profile.",
    interested: "I'm interested",
    notInterested: 'No thanks',
    doTest: 'I will take the test!',
  },
  onboardingSignupValidationSlideFreemium: {
    title: '🎉 Your account is created!',
    welcome: 'Welcome to Tokatab 👋',
    intro: 'Here is what awaits you:',
    step1: 'Hundreds of exercises, pieces, and challenges created by professional teachers.',
    step2: 'A virtual coach who guides you according to your progress and needs',
    step3: 'New skills to unlock at every stage',
    step4: 'Real progress — especially if you practice regularly. 😉',
    continue: 'Continue',
  },
  onboardingSignupValidationSlideAb: {
    title: 'Join thousands of beginner and advanced musicians progressing at the piano with <strong>Tokatab</strong>',
    rating: 'Play Store',
    testimonial: '" I am pleasantly surprised by this program which allows me to get back to the piano after a long break. I really enjoy following the lessons and learning the pieces. Thank you! "',
    user: '<strong>Myriam</strong>, user<br />Tokatab since 2023',
    continue: 'Continue',
  },
  onboardingSignupValidationSlide: {
    title: 'Your registration is complete!',
    intro: 'As your virtual teacher, I will be delighted to support you in your learning. Together we will cover:',
    exercises: '{count} exercises, challenges and videos',
    exercisesDesc: 'to help you discover and practice the main piano techniques (melodic playing, chords, arpeggios, rhythmic patterns, hand independence, etc.)',
    pieces: '{count} complete pieces',
    piecesDesc: 'arranged by musicians, for all levels, to apply your new skills in a fun and musical way.',
    continue: 'Continue',
  },
  onboardingSelectDisplayModeSlide: {
    askTitle: 'Can you read music?',
    askSubtitle: 'This helps me choose the best display mode for you.',
    selectTitle: 'Which display mode do you want to start with?',
    selectSubtitle: 'On Tokatab, sheet music is available — but optional.',
    answerNone: 'No',
    answerSol: 'I can read a little treble clef',
    answerSolFa: 'I can read a little treble and bass clef',
    answerRead: 'Yes, I can read music well',
    partition: 'Sheet music',
    pianoRoll: 'Piano roll',
    recommended: 'Recommended for you',
    changeAnytime: 'You can change your choice at any time',
  },
  onboardingPlugKeyboardSlide: {
    titlePlug: 'Plug your keyboard into your device!',
    titleDetected: 'Your keyboard has been detected!',
    titleSuccess: 'Great!',
    plugInstruction: 'With a compatible MIDI cable, plug Tokatab directly into your device. Tokatab will be able to give you optimal and continuous feedback.',
    playC: 'Press and hold middle C (marked by the small green dot on its left).',
    keyFeedback: 'Keys turn green when you play correctly, and red if there’s a mistake.',
    tooLow: 'Play a little higher on the keyboard!',
    tooHigh: 'Play a little lower on the keyboard!',
    helpMidi: 'How to connect a MIDI keyboard, with which cable?',
    helpPlug: 'I need help connecting my keyboard.',
    success: 'I will be able to support you optimally throughout your learning journey by taking your playing into account.',
    noCable: "I don't have a suitable cable",
    next: 'Next',
  },
  onboardingNotificationSlide: {
    title: 'Your session schedule',
    sessionsInfo: 'Short but regular sessions are the best way to progress. Plan your practice slots and I will remind you at the right time.',
    whichDays: 'On which days do you have 15 minutes or more?',
    notificationsInfo: 'To send you practice reminders, please enable notifications for Tokatab.<br>You can easily disable them at any time if you wish.',
    mustSelectDay: 'You must select at least one day for your piano session.',
    mustUseMobile: 'You must use the mobile app to enable notifications.',
    noActivate: 'Not now',
    activate: 'Enable notifications!',
    noPlanning: 'Do not set a slot',
    continue: 'Continue'
  },
  notificationsPermission: {
    title: 'A reminder at the right time helps',
    content1: 'To help you progress faster, turn on notifications.',
    content2: 'I’ll remind you at the right time to review the most important concepts.',
    later: 'Later',
    enable: 'Enable notifications',
  },
  onboardingNewsSlide: {
    title: 'We have some news for you!',
    subtitle: 'We need a few details to activate them, don\'t worry, it will be quick!',
    continue: 'Continue'
  },
  onboardingNameSlide: {
    title: 'Let\'s get to know each other!',
    question: 'What should I call you?',
    label: 'Your first name or nickname',
    required: 'Enter your first name',
    tooLong: 'Name too long',
    continue: 'Continue'
  },
  onboardingMandatoryPlayerSlide: {
    title: 'Let\'s adapt your experience!',
    subtitle: 'To allow you to use these features, we need a few more details.<br>You will need your piano for the next steps.',
    noPiano: 'I don\'t have my piano',
    letsGo: 'Let\'s go!'
  },
  onboardingLevelSlideResult: {
    buildingTitle: 'Building your personalized path…',
    estimateTitle: 'Your personalized path is ready!',
    pathDescription1: 'You’ll start from scratch and build strong technical foundations step by step.',
    pathDescription3: 'You’ll strengthen your foundations and develop your first coordination skills with both hands.',
    pathDescription5: 'You’ll build greater fluency by practicing the most common patterns used by amateur pianists and exploring more advanced techniques.',
    testInfo: 'You can change this path at any time if it doesn’t suit you.',
    continue: 'Continue'
  },
  onboardingLevelSlide: {
    title: "What's your level at the piano?",
    pathTitle: 'Choose the option that best describes the learning path that suits you in piano',
    neverPlayed: "I've never played",
    oneHand: 'I can play a few notes with one hand',
    oneHandBack: 'I used to play short pieces with one hand',
    simpleTwoHands: 'I can play very simple pieces with both hands',
    simpleTwoHandsBack: 'I used to play simple pieces with both hands',
    longTwoHands: 'I can play simple and fairly long pieces with both hands',
    longTwoHandsBack: 'I used to play fairly long pieces with both hands',
    complex: 'I can play long and technically complex pieces',
    complexBack: 'I used to play long and technically complex pieces'
  },
  onboardingKeyboardSlideResultNotCompatible: {
    title: 'Your platform is not compatible',
    chromeOnly: 'Unfortunately, only the Chrome browser currently supports midi recognition. We invite you to download and use it for Tokatab if you want to connect your compatible keyboard.',
    openChrome: 'Continue with Chrome',
    alreadyChrome: 'If you already have Google Chrome, just open the browser and return to app.tokatab.com.',
    installChrome: 'Otherwise, you can install Chrome by clicking the logo below:',
    continueWithoutMidi: 'Continue without midi', 
  },
  onboardingKeyboardSlideResult: {
    noPianoYet: 'No piano yet?',
    noPianoNoWorries: 'No worries!',
    exploreApp: 'You can explore the app and see how it works. We’ve prepared a guide to help you 👇',
    buyingGuide: '📖 Buying guide',
    buyingGuideLabel: 'Piano buying guide',
    seeBlog: 'See on the blog',
    continue: 'Continue',
  },
  onboardingKeyboardSlide: {
    selectType: 'Tokatab can detect the notes you play. What type of piano do you use?',
    digital: 'A digital piano / a synthesizer',
    acoustic: 'An acoustic piano',
    dontKnow: 'I don\'t know',
    changeLater: 'You can always change this choice later!',
    selectMethod: 'You have two solutions to let Tokatab capture your playing, choose one of the two',
    withMic: 'With the microphone',
    micDesc1: 'Analyzes the sound of your piano and recognizes the notes played',
    micDesc2: 'Privacy assured: recordings stay on your device and are systematically deleted',
    withMidi: 'With a cable',
    midiDesc1: 'Even more accurate than using the microphone',
    midiDesc2: 'Requires a suitable cable (we will guide you to find the right one if needed)',
    notCompatible: 'Oops, it seems your device is not compatible with this feature',
    notAllowed: 'Oh, you denied access to the microphone!',
    digitalUnplugged: 'Tokatab with an unplugged digital piano!',
    acousticMic: 'Tokatab with an acoustic piano',
    micNeeded1: 'Note detection is possible thanks to your device\'s microphone. To enjoy this feature, we need access to your mic.',
    micNeeded2: 'We respect your privacy: recordings will be analyzed on your device and never saved! The mic is only used when listen mode is enabled, never by default.',
    privacyRespect: 'We respect your privacy: recordings will be analyzed on your device and never saved! The mic is only used when listen mode is enabled, never by default.',
    listenMode: "Throughout your journey, by clicking this button <q-icon color='white' name='mdi-ear-hearing' size='15px' class='disable-button q-pa-xs' /> you will activate <strong>listen mode</strong> which will allow me to hear your piano and give you feedback.",
    listenModeValidated: 'Throughout your journey, by clicking this button you will activate <strong>listen mode</strong> which will allow me to hear your piano and give you feedback.',
    notAllowedInfo1: 'If you change your mind, just click this button again to enable <strong>listen mode</strong> and let the virtual teacher know if you are playing the right notes or not.',
    notAllowedInfo2: 'We will show you again how to allow your mic.',
    fallback1: 'The Tokatab virtual teacher can still personalize your learning path.',
    fallback2: 'You can try to redo your device\'s performance test or move on.',
    allowMic: 'Allow mic access',
    retry: 'Retry',
    continue: 'Continue',
    powerQuestion: 'Does your piano need electric power to work?',
    yes: 'Yes',
    no: 'No',
    willHelp: 'I will still help you!',
    willAdapt: 'Throughout your learning journey, I will adapt my recommendations based on your answers to my questions.',
    noPianoTitle: 'Tokatab without piano',
    noPianoAdvice: 'Without a piano, it is difficult to progress with Tokatab. Feel free to read our articles if you are looking for advice on getting a piano.',
    guide1: 'Read the guide to buying a piano between 50 and 200€!',
    guide2: 'Read the guide to buying a piano for 300€!',
    needPianoTitle: 'Which instrument will you play on?',
    digitalPiano: 'Digital piano / Synthesizer',
    acousticPiano: 'Acoustic piano',
    midiKeyboard: 'MIDI Keyboard',
    noPiano: 'I don\'t have a piano yet',
    keyboardInfo: {
      digitalTitle: "Digital piano / Synthesizer",
      digitalContent1: "It must be plugged into an electrical outlet to work.",
      digitalContent2: "It produces sound through its built-in speakers.",
      digitalContent3: "It has a USB or MIDI port.",
      acousticTitle: "Acoustic piano",
      acousticContent1: "Either an upright piano or a grand piano.",
      acousticContent2: "It has strings that generate sound and does not need to be plugged into an electrical outlet.",
      midiTitle: "MIDI Keyboard",
      midiContent1: "Like a computer mouse, it is a controller.",
      midiContent2: "It does not produce any sound by itself.",
      midiContent3: "It must be connected to music software to control sounds.",
    },
    buyingGuide300: 'Buying guide for a piano around 300€',
    buyingGuideShort300: 'Piano buying guide 300€',
    buyingGuide50to200: 'Buying guide for a piano between 50 and 200€',
    buyingGuideShort50to200: 'Piano buying guide 50-200€',
  },
  onboardingInitialOnboardingEndSlide: {
    title: 'Discover the app!',
    missions: 'Missions are waiting for you on the home screen — and they start right now.',
    progressPill: 'Discovery path — {done}/{total} already completed ✓',
    discover: 'Discover Tokatab',
    downloadTitle: 'Download the app to use Tokatab!',
    downloadCta: 'Click the button below to install the app'
  },
  onboardingInitialEvaluationSlide: {
    title: 'It\'s time to play piano!',
    intro: 'To get you familiar with Tokatab and its notation, and to know your piano skills, we offer you a placement test!',
    challenges: 'It\'s a series of increasingly difficult challenges that will allow us to validate your skills!',
    program: 'We can then prepare a tailor-made program to help you progress.',
    start: 'Let\'s go!'
  },
  onboardingHasPianoSlide: {
    question: 'Do you have your piano with you?',
    subtitle: "If so, I'll offer you a mini tutorial — a few notes to play right away.",
    yes: 'Yes',
    no: 'No'
  },
  onboardingHandSizeSlide: {
    titlePresentation: 'Hand size calculation',
    titleLeft: 'Left hand size calculation',
    titleRight: 'Right hand size calculation',
    titleEnding: 'Thank you!',
    btnContinue: 'Continue',
    btnRetry: 'Retry test',
    btnConfirm: 'Confirm',
    slideTextPresentation: 'We’ll measure your hand span to tailor your exercises to your hands.<br> This helps avoid giving you pieces or exercises that feel uncomfortable or unsuitable.',
    slideTextEnding: "Your hand span has been saved..<br>I’ll use it to adapt your learning experience from now on.<br>If needed, you can redo this test at any time in your profile.",
    errorPlacementWrong: 'Please place your thumb on middle C and do not cross your fingers.',
    errorTooLarge: 'It is not possible to have such a large hand!',
    warningTooSmall: 'Are you sure you are opening your hand as much as possible?',
    warningSmall: 'Are you sure you can’t stretch a little further?',
    warningLarge: 'What a hand! Are you sure you are using the same hand for both keys?',
    stepRight: 'Press middle C with your right thumb.<br>While holding this key down, play the farthest note possible with your little finger, then indicate this note on the keyboard below.<br><strong>Do not force too much, it should remain “comfortable.”</strong>',
    stepLeft: 'In the same way, press middle C with your left thumb.<br>While holding this key down, play the farthest note possible with your little finger, then indicate this note on the keyboard below.<br><strong>Do not force too much, it should remain “comfortable.”</strong>',
    midiRight: 'Press middle C with your right thumb.',
    midiLeft: 'In the same way, press middle C with your left thumb.',
    midiFingers: 'While holding this key down, play the farthest note possible with your little finger.',
    midiHold: 'Hold both keys for 5 seconds to confirm!',
    results: 'Please confirm your hand size or redo the test. (be careful not to stretch your hand too much, The goal is to find the largest comfortable stretch you can play.)'
  },
  onboardingGoalSlide: {
    title: 'What are your goals at the piano?',
    subtitle: 'Select all that apply — this helps me build the right path for you.',
    continue: 'Continue'
  },
  onboardingGenericEndSlide: {
    title: 'Thank you for these details!',
    subtitle: 'Now it\'s your turn to play!',
    finish: 'Finish'
  },
  onboardingChecklistRecap: {
    title: 'Discover Tokatab',
    description: 'Complete these missions to get the most out of Tokatab.',
    daysUnlocked: 'You have unlocked <span class="text-primary text-bold">{count} extra</span> free trial days!',
    daysNotUnlocked: 'You have not unlocked any extra free trial days yet.',
    daysLeft: 'You have <span class="text-primary text-bold">{count} left to unlock</span>.',
    allDaysUnlocked: 'You have unlocked all free trial days! Complete this list to discover all Tokatab features!',
    missions: 'missions',
    seeRemaining: 'See remaining missions',
    hide: 'Hide',
    hideNotify: 'This list will no longer appear on the home page, you can find it in your profile.',
    hideNotifyOk: 'You can find this list in your profile.'
  },
  onboardingChecklistPage: {
    title: 'Discover Tokatab',
    back: 'Back',
    trialDay: 'day',
    toUnlock: 'of trial period to unlock',
  },
  onboardingChecklistController: {
    basic_info: '👀 Describe your piano level',
    objectives: '🎯 Set your goals',
    equipment: '🎹 Which piano do you use?',
    hand_size: '🤲 Let\'s measure your hand size',
    training_program: '🗓 Let\'s set up your schedule',
    email_validation: '💌 Validate your email',
    singing: '🎤  Let\'s determine your vocal range',
    initial_evaluation: '🥇 Take your piano level test',
    tokatab_exercises: '📘 Complete your first exercise',
    import_my_piece: '📥 Import your first piece',
    first_module: '🎓 Complete your first module',
    plug_piano: '🔌 Plug in your piano!',
    notify_first_song: 'Here is the list of songs, choose one and complete a part using guided mode to finish this objective!',
    notify_tokatab_exercises: 'Here is the list of modules, choose one and complete at least one exercise to finish this objective.',
    notify_first_module: 'Here is the list of modules, choose one and complete it to finish this objective.',
    notify_checklist_complete: 'Congratulations, you have completed the checklist and are now ready to enjoy all Tokatab features!',
    notify_mission_complete: 'Congratulations, you have completed one of the discovery missions!',
    notify_mission_complete_days: 'You have earned {count} extra free trial day(s)!',
    notify_import_my_piece: 'Here is the import tool, import a piece to finish this objective.',
  },
  onboardingIntroJsService: {
    nextMobile: '>',
    nextDesktop: 'Next',
    prevMobile: '<',
    prevDesktop: 'Previous',
    doneMobile: 'x',
    doneDesktop: 'Done',
    hintButton: "Got it"
  },

  onboardingSongPageData: {
    hints: {
      listen: 'Click here to listen to the song.',
      lyrics: 'In this tab, you will find the full lyrics of the song. Feel free to review them so you can accompany yourself on the piano.'
    }
  },

  onboardingPlayerData: {
    PlayerTour: {
      listenButton: {
        title: 'Listening mode',
        intro: 'Click this button to activate listening mode and let the Tokatab teacher give you feedback based on the notes you play.'
      }
    },
    PlayerFreeModeTour: {
      loop: {
        title: 'Practice at your own pace',
        intro: 'Click here to activate a loop on the part you are on.'
      },
      speed: {
        title: 'Practice at your own pace',
        intro: 'Here you control the playback speed, a very important button to practice the song by lowering the speed!'
      },
      help: {
        title: 'Practice at your own pace',
        intro: 'Finally, this button is very important! It allows you to activate step-by-step learning assistance for the song.'
      }
    },
    PlayerClassTour: {
      step1: {
        title: 'Lesson mode',
        intro: 'Here Tokatab guides you step by step to learn the song!'
      },
      step2: {
        title: 'Lesson mode',
        intro: 'Each colored letter corresponds to a section. It is a shorter, easily memorable musical passage!'
      },
      step3: {
        title: 'Lesson mode',
        intro: 'Playing a part means chaining all its sections.'
      },
      step4: {
        title: 'Lesson mode',
        intro: 'Often different parts have sections in common that only need to be learned once.'
      }
    },
    PlayerScoreEvolutionTour: {
      step1: {
        title: 'Scores',
        intro: 'The score goes from 0 to 100 and indicates how easy this song or challenge will be for you to learn.'
      },
      step2: {
        title: '100% personalized',
        intro: 'This score is 100% personalized and calculated based on the techniques you have already practiced on Tokatab. The more challenges, songs, and exercises you play, the higher the score!'
      }
    },
    ShowParameterTour_tempo: {
      step1: {
        title: 'Change the tempo',
        intro: 'Here you can control the playback speed!'
      }
    },
    ShowParameterTour_sound: {
      step1: {
        title: 'Control volumes',
        intro: 'Here you can increase or decrease the volumes!'
      }
    },
    ShowParameterTour_MobileDisplayMenu: {
      step1: {
        title: 'Control display',
        intro: 'Here you can change various display settings!'
      }
    },
    ShowParameterTour_displayFingerOrNotes: {
      step1: {
        title: 'Display notes or fingerings',
        intro: 'Here you can choose to display fingerings or notes!'
      }
    },
    ShowParameterTour_listenModeButton: {
      step1: {
        title: 'Listening mode',
        intro: 'Click this button to activate listening mode and let the Tokatab teacher give you feedback based on the notes you play.'
      }
    },
    ShowParameterTour_sheetMusicMode: {
      step1: {
        title: 'Piano roll or sheet music mode',
        intro: 'By clicking this button you can choose between piano roll mode or sheet music mode!'
      }
    }
  },

  onboardingHomeData: {
    hints: {
      challenge: "Remember, if you don't have much time, completing challenges is a quick way to progress on key piano concepts while having fun!",
      profil: "From your Profile page, you can manage your subscription and Tokatab settings.",
      filterVersion: "Inspired versions contain the main elements of the song that make them very recognizable. Original versions are almost identical to the original recordings.",
      sortBy: 'Sorting results "by mastery" displays first the songs you will have the least difficulty learning, because you already know some of their techniques.'
    }
  },

  onboardingIntroPlayerModal: {
    slides: {
      tuto_welcome: { content: 'Let me show you how to play with Tokatab through a tutorial challenge.<div class="q-mt-sm">Challenges are short practical excerpts to review and apply your piano skills.</div>' },
      tuto_validation: { content: 'Like all the content in the app, you will need to play this challenge at 100% tempo to complete it.' },
      piano_1: { content: 'Tokatab uses a notation-free mode.' },
      piano_2: { content: 'You will see on your screen the keys to play on your piano.' },
      piano_3: { content: 'The <span class="text-orange">orange</span> keys are to be played with your <span class="text-orange">right hand</span> fingers.' },
      piano_4: { content: 'The <span class="text-primary">blue</span> keys are to be played with your <span class="text-primary">left hand</span> fingers.' },
      piano_5: { content: "When a key lights up on the app's virtual keyboard, you must play it on your piano and hold it down as long as it is lit." },
      piano_7: { content: "The numbers on the keys show you which finger to use. Be sure to follow them!<br>(1 for thumb, 2 for index, etc.)<br><img src='{img}' alt='piano fingers' style='width: 70%'>" },
      piano_8: { content: "To play the short excerpt that follows, you will use only your right hand with fingers 1 (thumb), 2 (index), and 3 (middle)." },
      partition_1: { title: 'Sheet music mode presentation', content: 'You will see the sheet music scroll from right to left.' },
      partition_2: { content: 'The keys to play are shown on the virtual keyboard below the sheet music.' },
      partition_3: { content: 'When the notes pass through this gray area, they light up and you must play them on your piano.' },
      partition_4: { content: 'Notes that light up in <span class="text-orange">orange</span> are to be played by the <span class="text-orange">right hand</span>.' },
      partition_5: { content: 'Notes lit up in <span class="text-primary">blue</span> are to be played by the <span class="text-primary">left hand</span>.' },
      partition_6: { content: 'As long as the notes are lit, you must keep the corresponding keys pressed on your piano.' },
      partition_7: { content: "The numbers on the keys show you which finger to use. Be sure to follow them!<br>(1 for thumb, 2 for index, etc.)<br><img src='{img}' alt='piano fingers' style='width: 70%'>" },
      play_button: { content: "Click this button to start the song and play it on your piano at the same time. \n A countdown will give you time to place your hand.", imageWidth: '140px' },
      capture_audio_button: { content: "By clicking this button you will activate listening mode, which allows the virtual teacher to detect your playing and give you feedback. You can make this button appear by clicking on the teacher icon." }
    }
  },

  onboardingAskKeyboardAvailability: {
    title: 'Let’s adapt your experience!',
    subtitle: "To help you get the most out of Tokatab, we need you to take a few tests.<br> You will need your piano for the next steps.",
    skip: "I don't have my piano",
    next: "Let's go!"
  },

  onboardingChallengeSlide: {
    title: 'It’s time to play piano!',
    intro: 'To get familiar with Tokatab and its notation, we offer you a little challenge.',
    description: 'This is a short excerpt from a song that you can quickly master and validate!',
    start: "Let's go!"
  },

  onboardingDaysNotificationSelector: {
    available: 'When are you usually more available?',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening'
  },

  onboardingEmailPasswordSlide: {
    passwordError: 'Min 8 characters with uppercase, lowercase and numbers',
    passwordConfirmError: 'You entered 2 different passwords',
    emailFormatError: 'Invalid email format',
    almost: 'Almost there!',
    choosePassword: 'Finally, choose your password',
    accountExists: 'Oops, it looks like an account already exists with this email!',
    twoSteps: 'Create your account to save your personalized path.',
    enterPassword: 'Enter your password to log in',
    email: 'Your email *',
    password: 'Your password *',
    passwordHint: 'Min 8 characters with uppercase, lowercase and numbers',
    passwordConfirm: 'Password confirmation *',
    passwordForgot: 'Forgot password?',
    continue: 'Continue',
    or: 'OR',
    createAccount: 'Create my account',
    login: 'Log in',
    legalNotice: 'By creating your account, you agree to our',
    legalNoticeLink: 'Terms of Use',
    invalidEmail: 'Invalid email format',
    newsletterConsent: 'I’d like to receive updates from Tokatab (no spam).',
  },
  onboardingCatalogPage: {
    hints: {
      listen: "Click here to import your own piece in MusicXML format",
    }
  }
}
